// @/store/useMutedStore.js
import { defineStore } from 'pinia'

export const useMutedStore = defineStore('muted', {
    state: () => ({
        isMuted: true,
        isInitialized: false, // Track if we've initialized from user interaction
    }),
    actions: {
        setMuted(value) {
            this.isMuted = value
            this.isInitialized = true
            localStorage.setItem('isMuted', value.toString())
        },
        initialize(hasInteracted) {
            // Only initialize once per session
            if (this.isInitialized) {
                return this.isMuted
            }

            // First load always muted
            if (!hasInteracted) {
                this.isMuted = true
                return true
            }

            // User has interacted, check localStorage
            const savedMuted = localStorage.getItem('isMuted')
            if (savedMuted !== null) {
                this.isMuted = savedMuted === 'true'
                this.isInitialized = true
            }

            return this.isMuted
        }
    }
})
